export const validateRegexpNumberFunction = val => {
  const preparedValue = String(val);

  const matches = preparedValue.match(/\d+([.]\d+)*/);

  if (!matches || !matches.length) return false;

  return matches[0].length === preparedValue.length;
};